<div class="template-upload-container">
    <div class="top-content-container">
        <div class="template-upload-title-container">
            <div class="top-content">
              <div class="title">Entity Viewer</div>
             
              <div class="button-container">
                <div class="dropdown-container">

                   <!-- parent dropdown -->
                  <div class="plant-dropdown-container" (clickOutside)="onClickedOutsidePlant()">
                      <div class="plant-dropdown entity-dropdown" (click)="toggleParentDropdown()" (keydown.enter)="toggleParentDropdown()">
                        <span appTooltip="{{selectedPlant?.PlantName }}" [tooltipPosition]="'top'"
                        [tooltipShow]="(selectedPlant?.PlantName?.length) > 20">
                          {{selectedPlant?.PlantName  | shorten: 20 }}
                        </span>
                        <span><img [src]="expandImage | assetImageUrl" alt="Expand"/></span>
                    </div>

                    <div class="plant-dropdown-options entity-dropdown-options" *ngIf="showParentDropdown">
                      <div [ngStyle]="{backgroundColor: plant.PlantName === selectedPlant?.PlantName ? selectedOptionBGColor : 'transparent'}" class="dropdown-option" (click)="selectPlant(plant)" (keydown.enter)="selectPlant(plant)" *ngFor="let plant of plantList">
                        <div class="plant-name">
                          <span appTooltip="{{plant?.PlantName }}" [tooltipPosition]="'top'"
                          [tooltipShow]="(plant?.PlantName?.length) > 24">
                            {{plant?.PlantName  | shorten: 24 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                  <div class="child-dropdown-container" (clickOutside)="onClickedOutsideChild()">
                    <div class="child-dropdown entity-dropdown" [ngClass]="isDisable ? 'isDisable' : ''" (click)="toggleChildDropdown()" (keydown.enter)="toggleChildDropdown()">
                      <span class="defaultSelect" *ngIf="!selectedChild; else displaySelectedChild">Select</span>
                       <ng-template #displaySelectedChild>
                        <span appTooltip="{{selectedChild }}" [tooltipPosition]="'top'"
                        [tooltipShow]="(selectedChild?.length) > 20">
                          {{selectedChild  | shorten: 20 }}
                        </span>
                      </ng-template>
                      <span><img [src]="expandImage | assetImageUrl" alt="Expand"/></span>
                    </div>
                  
                  
                    <div class="child-dropdown-options entity-dropdown-options" *ngIf="showChildDropdown">
                        <div [ngStyle]="{backgroundColor: child === selectedChild ? selectedOptionBGColor : 'transparent'}" class="dropdown-option" (click)="selectChild(child)" (keydown.enter)="selectChild(child)" *ngFor="let child of childList">
                          <div class="child-name">
                            <span appTooltip="{{child }}" [tooltipPosition]="'top'"
                            [tooltipShow]="(child?.length) > 24">
                              {{child | shorten: 24 }}
                            </span>
                          </div>
                        </div>
                    </div>
                  </div>

                </div>
                <button type="button" class="button-container--upload" (click)="onUploadTemplateClicked()">UPLOAD TEMPLATE <img [src]="uploadImage | assetImageUrl" alt=""></button>
                <button type="button" [disabled]="isDisableButton" class="button-container--download" (click)="downloadExcel()">DOWNLOAD TEMPLATE <img [src]="downloadImage | assetImageUrl" alt=""></button>
              </div>
            </div>
            <div class="note">Upload template is used to upload the Configured Entity viewer template .</div>
        </div>
    </div>

    <div class="template-list-container">
        <div class ="template-count">
            <p class="mb-0">TEMPLATES ({{ dataSource.filteredData.length ? dataSource.filteredData.length : '0'}}){{ selectedPlant ? ' - ' : '' }}<span>{{ selectedPlant ? selectedPlant.PlantName : '' }}{{selectedChild ? ' / ' + selectedChild : ''}}</span></p> 
            <mat-paginator
              [hidden]="!dataSource.filteredData.length"
              [pageSize]="limit"
              hidePageSize="true"
              showFirstLastButtons>
            </mat-paginator>
        </div>
        <div class="line-divider">
            <div class="circle"></div>
            <div class="line"></div>
            <div class="circle"></div>
        </div> 
        <div [ngClass]="!dataSource.filteredData.length ? 'table-container no-template' : 'table-container'">
           <ng-container *ngIf="isLoading">
            <div class="loading-templatelist">
                <app-three-dots-loading class="dots"></app-three-dots-loading>
                <div class="text">Loading Templates...</div>
            </div>
          </ng-container>

          <ng-container *ngIf="!dataSource.filteredData.length; else showTable">
            <div class="no-config-message">
                <img class="icon" [src]="errorImage | assetImageUrl" alt="Error"/>
                <div class="message">NO CONFIGURED TEMPLATES HAVE BEEN ADDED</div>
            </div>
          </ng-container>

          <ng-template #showTable>
            <!-- table -->
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                                
              <!-- Asset hierarchy level Column -->
              <ng-container matColumnDef="AssetType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset hierarchy level </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.AssetType}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.AssetType?.length) > 24">
                      <div>
                        {{element?.AssetType | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

              <!-- Plant Column -->
              <ng-container matColumnDef="PlantName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Plant </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.PlantName}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.PlantName?.length) > 24">
                    {{element?.PlantName | shorten: 24 }}
                  </span>
                </td>
              </ng-container>
            
              <!-- Version Column -->
              <ng-container matColumnDef="Version">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Version </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.Version}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.Version?.length) > 24">
                    {{element?.Version | shorten: 24 }}
                  </span>
                </td>
              </ng-container>

              <!-- CreatedByUserName by Column -->
              <ng-container matColumnDef="CreatedByUserName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Created by </th>
              <td mat-cell *matCellDef="let element">
                <span appTooltip="{{element?.CreatedByUserName}}" [tooltipPosition]="'top'"
                [tooltipShow]="(element?.CreatedByUserName?.length) > 24">
                  {{element?.CreatedByUserName | shorten: 24 }}
                </span>
              </td>
              </ng-container>

              <!-- CreatedOn Column -->
              <ng-container matColumnDef="CreatedOn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created on </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.CreatedOn}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.CreatedOn?.length) > 24">
                    {{element?.CreatedOn | date:'dd.MM.yyyy' | shorten: 24 }}
                  </span>
                </td>
              </ng-container>

              <!-- UpdatedByUserName Column -->
              <ng-container matColumnDef="UpdatedByUserName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated by </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.UpdatedByUserName}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.UpdatedByUserName?.length) > 24">
                    {{element?.UpdatedByUserName | shorten: 24 }}
                  </span>
                </td>
              </ng-container>

                <!-- UpdatedOn Column -->
                <ng-container matColumnDef="UpdatedOn">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated on </th>
                  <td mat-cell *matCellDef="let element">
                    <span appTooltip="{{element?.UpdatedOn}}" [tooltipPosition]="'top'"
                    [tooltipShow]="(element?.UpdatedOn?.length) > 24">
                      {{element?.UpdatedOn | date:'dd.MM.yyyy' | shorten: 24 }}
                    </span>
                  </td>
                </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </ng-template>
          <!-- end -->
      </div>
    </div>
</div>



